<template>
  <crud-layout
    :title="title"
    :subtitle="subtitle"
    :add-button="true"
    @add="create"
  >
    <template v-slot:list>
      <tamanio-list
        ref="list"
        @update="update"
        @delete="remove"
        @show="show"
      />
    </template>

    <tamanio-create
      v-if="creating"
      :open="creating"
      v-on:itemCreated="onItemCreated"
      v-on:close="creating = false"
    />

    <tamanio-update
      v-if="updating"
      :open="updating"
      :item="itemToEdit"
      v-on:itemUpdated="onItemUpdated"
      v-on:close="updating = false"
    />

    <tamanio-show
      v-if="showing"
      :open="showing"
      :item="itemToShow"
      v-on:close="showing = false"
    />

    <tamanio-delete
      v-if="deleting"
      :open="deleting"
      :item="itemToDelete"
      v-on:itemDeleted="onItemDeleted"
      v-on:close="deleting = false"
    />

    <snackbar v-model="flash" />
  </crud-layout>
</template>

<script>
import TamanioCreate from "../TamanioCreate";
import TamanioUpdate from "../TamanioUpdate";
import TamanioDelete from "../TamanioDelete";
import TamanioShow from "../TamanioShow";
import TamanioList from "../TamanioList";

import { CrudLayout, Snackbar } from "@dracul/common-frontend";

export default {
  name: "TamanioCrud",
  components: {
    CrudLayout,
    Snackbar,
    TamanioCreate,
    TamanioUpdate,
    TamanioDelete,
    TamanioShow,
    TamanioList,
  },
  data() {
    return {
      title: "tamanio.title",
      subtitle: "tamanio.subtitle",
      flash: null,
      creating: false,
      updating: false,
      deleting: false,
      showing: false,
      itemToEdit: null,
      itemToDelete: null,
      itemToShow: null,
    };
  },
  methods: {
    //On
    onItemCreated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.created");
    },
    onItemUpdated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.updated");
    },
    onItemDeleted() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.deleted");
    },
    //Open
    create() {
      this.creating = true;
    },
    update(item) {
      this.updating = true;
      this.itemToEdit = item;
    },
    show(item) {
      this.showing = true;
      this.itemToShow = item;
    },
    remove(item) {
      this.deleting = true;
      this.itemToDelete = item;
    },
  },
};
</script>


